var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("p", [_vm._v(_vm._s(_vm.$t("DeadlineChange.Description")))]),
      _vm._v(" "),
      _c("single-select-row", {
        attrs: {
          id: "aid-target-number",
          value: _vm.selectedAidTarget,
          options: _vm.aidTargets,
          required: true,
          title: "DeadlineChange.ChooseAidTarget",
          titleSelector: _vm.aidTargetTitleFn,
          isReadonly: _vm.isReadOnly
        },
        on: { input: _vm.setAidTarget }
      }),
      _vm._v(" "),
      _c("single-select-row", {
        attrs: {
          id: "aid-year",
          value: _vm.selectedAidYear,
          options: _vm.aidYears,
          required: true,
          title: "DeadlineChange.ChooseAidYear",
          titleSelector: _vm.aidYearTitleFn,
          isReadonly: _vm.isReadOnly
        },
        on: { input: _vm.setAidYear }
      }),
      _vm._v(" "),
      _c("text-label-row", {
        ref: "purpose",
        attrs: { title: "Purpose", value: _vm.request.purpose }
      }),
      _vm._v(" "),
      _c("numeric-input-row", {
        ref: "approximate-amount",
        attrs: {
          id: "approximate-amount",
          title: "DeadlineChange.ApproximateAmount",
          required: true
        },
        model: {
          value: _vm.request.approximateAmount,
          callback: function($$v) {
            _vm.$set(_vm.request, "approximateAmount", $$v)
          },
          expression: "request.approximateAmount"
        }
      }),
      _vm._v(" "),
      _c("text-area-row", {
        ref: "arguments",
        attrs: {
          title: "DeadlineChange.Arguments",
          id: "arguments",
          required: true,
          maxLength: 4000,
          rows: 5
        },
        model: {
          value: _vm.request.arguments,
          callback: function($$v) {
            _vm.$set(_vm.request, "arguments", $$v)
          },
          expression: "request.arguments"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }